import { useGetUserEnrollmentTimeline, useGetUserUniversitiesApplyingTo } from '@actions';
import EnrollmentTimeline from './EnrollmentTimeline';

interface UserEnrollmentTimelineProps {
  userId: string;
}

const UserEnrollmentTimeline = ({ userId }: UserEnrollmentTimelineProps) => {
  const { data: timelineData, isLoading } = useGetUserEnrollmentTimeline(userId);
  const { data: universitiesData } = useGetUserUniversitiesApplyingTo(userId);

  return (
    <EnrollmentTimeline
      timelineData={timelineData}
      universitiesData={universitiesData}
      isLoading={isLoading}
    />
  );
};

export default UserEnrollmentTimeline;
